const manualEntry = "Manual Entry";
const csvUpload = "Upload CSV";
const addDetails = "Add Details";
const reviewAndCreate = "Review & Create";
export const CSVUploadStepperSteps = [csvUpload, addDetails, reviewAndCreate];
export const manualEntryStepperSteps = [
  manualEntry,
  addDetails,
  reviewAndCreate,
];
